import {useHierarchyNavAccess} from '@domain/kpis'
import {getTranslationKey} from '@hconnect/common/utils'
import {Grid} from '@mui/material'
import {AreaDashboardContainer, AreaFilterContainer} from '@widgets/area-dashboard'
import {useTranslation} from 'react-i18next'

import {useTranslationPrefix} from '../../../shared/hooks'
import {LocationBreadcrumbs} from '../../components'
import {AreaReliabilityEngineerCardContainer} from '../../containers'
import {useHrocMapMarkersData} from '../../hooks'
import {AREA_ROUTE_SEGMENTS, RELIABILITY_ENGINEER_DASHBOARD} from '../../routing'
import {SHIFT_QUICK_SELECT_SLOTS, QuickSelectTimeRange} from '../../types'

export const AreaReliabilityEngineerDashboard = () => {
  const {t} = useTranslation()
  const {hrocPrefix} = useTranslationPrefix()

  const {allowedAreas, getAreaById} = useHierarchyNavAccess('VIEW_RELIABILITY_ENGINEER_DASHBOARD')

  return (
    <AreaDashboardContainer
      dashboardTitle={t(getTranslationKey('reliabilityEngineerDashboard.pageTitle', hrocPrefix))}
      dashboardRoute={RELIABILITY_ENGINEER_DASHBOARD}
      routeSegments={AREA_ROUTE_SEGMENTS}
      permission="VIEW_RELIABILITY_ENGINEER_DASHBOARD"
      useMapMarkersDataHook={useHrocMapMarkersData}
      useAccessHook={useHierarchyNavAccess}
      getPlantCards={(args: PlantCardsListProps) => <PlantCardsList {...args} />}
      allowedAreas={allowedAreas}
      getAreaById={getAreaById}
      fallbackBreadcrumbs={<LocationBreadcrumbs sx={{ml: 0}} />}
      headerActionContent={
        <AreaFilterContainer
          quickSelectSlots={SHIFT_QUICK_SELECT_SLOTS}
          defaultSlot={QuickSelectTimeRange.Today}
        />
      }
    />
  )
}

type PlantCardsListProps = {
  plantIds: string[]
  spacing?: number
  columnsCount?: number
  kpiGridItemXs?: number
}

const COLUMN_SIZE = 1
const PlantCardsList = ({
  plantIds,
  spacing = 2,
  columnsCount = 1,
  kpiGridItemXs = 4
}: PlantCardsListProps) => {
  return (
    <Grid container spacing={spacing} columns={columnsCount * COLUMN_SIZE}>
      {plantIds.map((plantId) => (
        <Grid item xs={COLUMN_SIZE} key={plantId}>
          <AreaReliabilityEngineerCardContainer
            plantId={plantId}
            cardBoxSx={{width: '100%'}}
            kpiGridItemXs={kpiGridItemXs}
          />
        </Grid>
      ))}
    </Grid>
  )
}
